// import { Button } from "@material-ui/core";
// import useLink from "./../hooks/useLink";
// import { makeThemedStyles } from "./../viewcomponents/utils";
import React from "react";
// import { useTranslation } from "react-i18next";
// import { AppLevelContext } from "./../context/AppCtx";
// import { useAppContext } from "./../context/AppCtxProvider";
// import { useMeaModelId } from "./../utils/model";
// import { getDefaultPeriod } from "./../context/periodDefaults";

/*
const useStyles = makeThemedStyles("PlanSwitchButton", (theme) => ({
  planButton: {
    position: "relative",
    padding: "0.33em 1.83em",
    color: "rgba(255, 255, 255, 0.8)",
    borderStyle: "solid",
    borderColor: "rgba(255, 255, 255, 0.24)",
    borderRadius: "5em",
    height: "2.83em",
    width: "17.5em",
    lineHeight: "2.08em",
    marginLeft: "5.5em",
    marginRight: "5.5em",
    borderWidth: "0.12em",
    textAlign: "center",
    fontSize: "1.6em",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    background: "transparent",
    justifyContent: "center",
    direction: "initial",
    whiteSpace: "nowrap",
    "&:hover": {
      background: "rgb(73,114,120)",
    },
  },
}));
*/
export default function PlanSwitchButton() {
  /*
  const classes = useStyles();
  const ctx = useAppContext() as AppLevelContext;
  const { t } = useTranslation();
  const navigate = useLink();
  // get allowed models
  const { data: modelMain1, isLoading: isModelLoading1 } =
    useMeaModelId("DP2021");
  const { data: modelMain2, isLoading: isModelLoading2 } =
    useMeaModelId("DP2030");
  if (isModelLoading1 || isModelLoading2) {
    return <span />;
  }
  const DP2021_id = modelMain1?.data[0]?.id;
  const DP2030_id = modelMain2?.data[0]?.id;
  const handleClick = () => {
    const model = ctx.modelId === "DP2021" ? "DP2030" : "DP2021";
    navigate({
      model,
      period: getDefaultPeriod(model),
    });
  };
  if (ctx.modelId === "DP2030" && !DP2021_id) {
    return <span />;
  }
  if (ctx.modelId === "DP2021" && !DP2030_id) {
    return <span />;
  }
  return (
    <Button role="button" onClick={handleClick} className={classes.planButton}>
      {t(
        `DUBAI PLAN ${
          ctx.modelId === "DP2021" ? "2030" : "2021"
        } Landing Page Button`
      )}
    </Button>
  );
  */
  return <></>;
}
